import PairingQr from './PairingQr';

interface PairingScreenProps {
  /** Six-digit code; empty while the session is opening. */
  code: string;
  /** Shown instead of the code while the page is opening or reconnecting. */
  status?: string | null;
}

/**
 * First pairing (TV_REVIVAL_PLAN.md §1.2): the code large, the QR of
 * `lagking://tv/pair?code=NNNNNN`, and where to find "Add a TV" in the app.
 * Nothing to click.
 */
export default function PairingScreen({ code, status }: PairingScreenProps) {
  return (
    <main className="splash">
      <div className="brand">LAG<span>KING</span></div>
      <section className="pair-panel">
        {code ? (
          <>
            <p className="kicker">PAIR THIS TV</p>
            <div className="pair-layout">
              <PairingQr code={code} />
              <div className="pair-code" aria-label={`Pairing code ${code.split('').join(' ')}`}>
                {code.slice(0, 3)}<span className="pair-code-gap" />{code.slice(3)}
              </div>
            </div>
            <p className="instruction">
              Open <strong>LagKing</strong> on your device: Settings, TV, Add a TV.
            </p>
            <p className="passive">Type the code or scan it. You only do this once.</p>
          </>
        ) : (
          <>
            <p className="kicker">LAGKING TV</p>
            <p className="instruction">{status ?? 'Opening…'}</p>
          </>
        )}
      </section>
    </main>
  );
}
